<template>
  <div class="regressionPC">
    <div class="tabbar" :class="navBarFixed ? 'navBarFixed' : ''">
      <img @click="goback" src="../../../../static/common/logo.png" alt="" width="130" height="31" />
      <div class="tabbar-right">
        <div class="tabbar-right-item">
          <img @click="toDownload" src="/subject/regression/download.png" width="25" height="31" alt="" />
          <p>APP下载</p>
        </div>
        <div class="tabbar-right-item">
          <img @click="openLive" src="/subject/regression/server.png" alt="" width="31" height="31" />
          <p>联系客服</p>
        </div>
      </div>
    </div>
    <div class="regression_header">
      <img class="regression_header-banner" src="/subject/regression/banner.png" alt="">
      <div class="regression_header-login" v-if="!isSign">
        <div class="login-box">
          <input
            v-model="form.phone"
            ref="inputElement"
            type="text"
            placeholder="请输入手机号"
          />
          <div class="codeBox">
            <input v-model="form.code" type="text" placeholder="请输入验证码" />
            <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
            <span v-else>重新获取({{ verSecond }})</span>
          </div>
          <img
            class="loginBtn"
            @click="submit(form)"
            src="/subject/regression/login-btn.png"
            alt=""
          />
        </div>
        
      </div>
      <div class="regression_header-trade" v-else>
        <p>
          <span>$199</span>回归礼已打入账户
          <br/>
          请您查收
        </p>
        <img
          class="tradeBtn"
          @click="toTrade"
          src="/subject/regression/trade-two-btn.png"
          alt=""
        />
      </div>
    </div>
    <div class="regression_body">
      <div class="active-info" v-if="isSign">
        <div class="active-info-title">
          <span>我的参与进度：</span>
          <span>
            <img src="/subject/regression/user-icon.png" alt="">
            交易账户：{{ activityInfo.account }}
          </span>
        </div>
        <div class="active-info-box">
          <div>
            <p class="active-info-box-title">
              1、回归赠礼：
              <span v-if="isStepOneHave">
                进行中，【<span class="active-info-time">{{ stepOneTime }}</span>】后结束
              </span>
              <span v-else>
                已结束
              </span>
            </p>
            <div class="active-info-box-left">
              <div class="active-info-box-item">
                <img src="/subject/regression/active1.png" alt="">
                <span class="active-status" v-if="activityInfo.sendStatus !== 3">已领取</span>
                <span class="active-status active-status-filed" v-else>已扣回</span>
              </div>
              <div class="active-info-box-item">
                <img src="/subject/regression/active2.png" alt="">
                <div class="active-target">
                  <p>目标手数：<span>3</span></p>
                  <p>我的手数：<span>{{ activityInfo.userJyLots || '-- '}}</span></p>
                </div>
              </div>
            </div>
          </div>
          <div class="active-info-box-right">
            <p :class="`active-info-box-title ${isStepOneOver && isStepTwoHave && 'active-info-box-title-deviation'}`">
              2、额外惊喜：
              <span v-if="!isStepOneOver">
                完成回归赠礼开启
              </span>
              <span v-else-if="isStepTwoHave">
                进行中，【<span class="active-info-time">{{ stepTwoTime }}</span>】后结束
              </span>
              <span v-else>
                已结束
              </span>
            </p>
            <div class="active-info-box-item">
              <img src="/subject/regression/active3.png" alt="">
              <div class="active-target">
                <p>目标手数：<span>10</span></p>
                <p>我的手数：<span>{{ activityInfo.userYxLots || '-- '}}</span></p>
              </div>
            </div>
          </div>
          <img class="right-icon" src="/subject/regression/right-icon.png" alt="">
        </div>
        <div class="active-info-btn">
          <img src="/subject/regression/customer-btn.png" alt="" @click="openLive">
          <img src="/subject/regression/trade-btn.png" alt="" @click="toTrade">
        </div>
      </div>
      <div class="regression_role">
        <img class="regression_role-bg" src="/subject/regression/role.png" alt="">
        <p class="regression_role-title">活动时间：</p>
        <p class="regression_role-content">【回归赠礼】 活动时长为7天， 【额外惊喜】 活动时长为30天。</p>
        <p class="regression_role-title">活动规则：</p>
        <p class="regression_role-content">
          1.【199美元现金】为平台为用户准备的 “回归赠礼” ， “回归赠礼” 有效期从领取当天起算（同时视为活动开始），7天后过期未使用系统将自动退回（7天后同时视为活动结束）。<br/>
          2.用户活动期间累计交易满3手可领$8现金红包，现金红包将在活动结束后统一派发。<br/>
          3.活动期间入金可获得与充值金额等额的美元赠金，即充多少送多少，赠金有效期为30天，最高可领10W美元赠金。<br/>
          4.活动结束后的30天内交易累计满10手额外再送$30美元现金。<br/>
          5.【199美元现金】只可直接用于交易，活动结束后扣回。活动期间产生的盈利归客户所有，盈利可提现可交易。<br/>
          6.如遇到节假日或特殊情况，奖励发放将顺延1-5日，敬请谅解。<br/>
          7.若用户中途退出活动，联系客服处理，届时活动奖励无法领取，额外惊喜活动也无法参与。<br/>
        </p>
        <p class="regression_role-title">注意事项：</p>
        <p class="regression_role-content">
          1.本平台开立真实交易账户。<br/>
          2.交易手数计算：开仓一手平仓一手，如此来回算一手，且开平仓需在活动期内。<br/>
          3.凡通过任何作弊手段或通过漏洞产生收益的，将取消参资格与奖励。<br/>
          4.本平台保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。<br/>
        </p>
      </div>
      <div class="regression_btn">
        <img src="/subject/regression/customer-btn.png" alt="" @click="openLive">
        <img v-if="!isSign" src="/subject/regression/receive-btn.png" alt="" @click="toReceive">
        <img v-else src="/subject/regression/trade-btn.png" alt="" @click="toTrade">
      </div>
      <div class="regression_download" ref="targetElement">
        <div class="regression_download-title">下载APP，获取更多福利资讯</div>
        <div class="regression_download-box">
          <div class="regression_download-box-code">
            <div class="regression_download-box-code-item">
              <Qrcode :link="iosMt4DownloadUrl" :size="150" :margin="0" :iconSize="28"/>
              <div class="regression_download-box-code-item-title">iOS</div>
            </div>
            <div class="regression_download-box-code-item">
              <Qrcode :link="androidMt4DownloadUrl" :size="150" :margin="0"/>
              <div class="regression_download-box-code-item-titleTwo">Android</div>
            </div>
          </div>
          <div class="regression_download-box-code">
            <div class="regression_download-box-code-item">
              <Qrcode :link="iosMt5DownloadUrl" :size="150" :margin="0"/>
              <div class="regression_download-box-code-item-title">iOS</div>
            </div>
            <div class="regression_download-box-code-item">
              <Qrcode :link="androidDownloadUrl" :size="150" :margin="0"/>
              <div class="regression_download-box-code-item-titleTwo">Android</div>
            </div>
          </div>
        </div>
        <p class="regression_download-tips">
          1、MT4版本用MT4账户，MT5版本用MT5账户，两者不互通；<br/>
          2、如无法确定所用账户的MT版本，请联系 <span @click="openLive">在线客服</span> 查询。<br/>
        </p>
      </div>
    </div>


    <div v-if="signResultDialog" class="signResultDialog">
      <div class="close-btn">
        <img class="hover" src="/subject/regression/close.png" alt="" @click="signResultDialog = false" />
      </div>
      <div v-if="isSign">
        <img src="/subject/regression/success.png" alt="" />
        <p>领取成功!</p>
        <img class="hover" src="/subject/regression/trade-two-btn.png" alt="" @click="toTrade"/>
      </div>
      <div v-else>
        <img src="/subject/regression/tips.png" alt="" />
        <p>不符合参与条件</p>
        <img class="hover" src="/subject/regression/website-btn.png" alt="" @click="toWebsite"/>
      </div>
      
    </div>

    <div class="dark" v-if="signResultDialog" @click="showDialog = false"></div>

    <contactusVue></contactusVue>

  </div>
</template>

<script>
import ContactusVue from "@/component/base-footer";;
import Qrcode from '@/component/QrCode/index.vue'
import { mapState, mapActions } from "vuex";
import userSign from '@/mixins/userSign';
import { postLogin } from '@/apis/user';
import { postSignActivityhg, queryHgActivityUserInfo } from '@/apis/active';
import { encryptCBC, getIMEI } from "@/utils/IMEI";
import { setToken, getToken, deleteToken } from "@/utils/cookies";
import { queryEmailCallback } from '@/apis/common';
export default {
  name: 'regressionPc',
  components: {
    ContactusVue,
    Qrcode,
  },
  mixins: [ userSign ],
  data() {
    return {
      screenWidth: null,
      navBarFixed: false,
      // 报名结果弹窗
      signResultDialog: false,
      // 是否已登录
      isLogin: false,
      // 是否已报名
      isSign: false,
      // 是否appt跳转
      isApp: false,
      activityInfo: {},
      isStepOneHave: false,
      isStepOneOver: false,
      stepOneTime: '',
      isStepTwoHave: false,
      stepTwoTime: '',
    };
  },
  computed: {
    ...mapState('common', {
      androidMt4DownloadUrl: 'androidMt4DownloadUrl',
      androidDownloadUrl: 'androidDownloadUrl',
      iosMt4DownloadUrl: 'iosMt4DownloadUrl',
      iosMt5DownloadUrl: 'iosMt5DownloadUrl',
    })
  },
  watch: {
    screenWidth: function(n) {
      if (n <= 500) {
        this.$router.push({
          name: 'regressionWap',
          query: this.$route.query || {}
        });
      }
    },
  },
  // created() {
  //   // 邮件模版点击
  //   if (this.$route.query.email) {
  //     queryEmailCallback({
  //       b: this.$route.query.jobid,
  //       e: this.$route.query.email,
  //       t: 0,
  //       r: '内部错误',
  //       u: window.location.href.split('?')[0],
  //       s: ''
  //     }).then(res => {
  //       console.log(res)
  //     })
  //   }

  //   this.$emit('controlShow', true);
  //   // 判断是从A前还是A后跳转过来
  //   if (!sessionStorage.getItem('craig')) {
  //     if (!this.$route.query.craig) {
  //       sessionStorage.setItem('craig', window.location.origin);
  //     } else {
  //       sessionStorage.setItem('craig', this.$route.query.craig);
  //     }
  //   }
  //   // 判断是否从app端跳转
  //   const queryData = this.$route.query;
  //   const { accessKey = '', from = '' } = queryData;
  //   if(from.startsWith('app')) {
  //     this.isApp = true;
  //   }
  //   if(accessKey) {
  //     setToken(accessKey)
  //   }
  //   if(this.isApp && !accessKey) {
  //     deleteToken();
  //   }
  //   const token = getToken();
  //   console.log('token', token)
  //   if(token) {
  //     this.getActivityUserInfo();
  //   }
  // },
  created() {
    this.$router.push({
      name: "Index"
    });
  },
  mounted() {
    //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    window.addEventListener('scroll', this.handleScroll);
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    ...mapActions('common', {
      getTradeWapLink: 'getTradeWapLink',
    }),
    // 返回上级页面
    goback() {
      window.location.href = sessionStorage.getItem('craig');
    },
    // 控制顶部的定位
    handleScroll() {
      this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      if (this.scroll > 90) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    openLive() {
      window.open(
        this.$parent.live800UrlUc
      );
    },
    toReceive() {
      const token = getToken();
      if(token) {
        this.activitySign();
      } else {
        this.toTop();
      }
    },
    // 回到顶部
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    // 下载
    toDownload() {
      const element = this.$refs['targetElement'];
      if (element) {
          element.scrollIntoView({ behavior: 'auto' });
      }
    },
    // 去交易
    async toTrade() {
      const h5LinkUrl = await this.getTradeWapLink();
      const sendData = {
        token: getToken(),
        userStatus: 3,
      }
      window.open(h5LinkUrl + '?sendKey=' + encodeURIComponent(encryptCBC(JSON.stringify(sendData))));
    },
    // 去官网
    toWebsite() {
      const { origin } = location;
      window.open(origin)
    },
    // 提交手机号验证码
    submit(form) {
      if (form.phone && form.code) {
        const params = {
          isSmsLogin: 1,
          account: form.phone,
          password: encryptCBC(form.code),
          clientId: getIMEI(),
          fromType: 'pc',
        }
        postLogin(params).then((res) => {
          setToken(res.Token)
          this.getActivityUserInfo('sign');
        });
      } else {
        this.$message({
          message: "请输入手机号和验证码！",
          type: "warning",
        });
      }
    },
    // 查询用户报名信息
    getActivityUserInfo(type) {
      queryHgActivityUserInfo().then(res => {
        this.isLogin = true;
        if(res) {
          this.isSign = true;
          this.activityInfo = res;
          const { cashCloseTime = 0, yxCloseTime = 0, delFlag } = this.activityInfo;
          if(delFlag === '1') {
            this.isStepOneHave = false;
            this.isStepOneOver = true;
            this.isStepTwoHave = false;
            return
          }
          const presentTime = Date.now();
          if(cashCloseTime && cashCloseTime > presentTime) {
            this.isStepOneHave = true;
            this.isStepOneOver = false;
            this.dataCountDown(cashCloseTime, 1);
          } else {
            this.isStepOneHave = false;
            this.isStepOneOver = true;
          }
          if(yxCloseTime) {
            this.isStepTwoHave = true;
            if(yxCloseTime < presentTime) {
              this.isStepTwoHave = false;
            } else {
              this.dataCountDown(yxCloseTime, 2);
            }
          } else {
            this.isStepTwoHave = false;
          }
        } else if(type === 'sign') {
          this.activitySign();
        }
       
      }).catch(e => {
        if(e.message === '登录已失效,请重新登录' || e.message === '您的账号已在其他设备登录,本机已登出') {
          this.isLogin = false;
          deleteToken();
        }
      })
    },
    // 用户报名活动
    activitySign() {
      if(this.isSign) {
        return this.$message({
          message: '您已经报名，请不要重复报名',
          type: "warning",
        });
      }
      postSignActivityhg().then(() => {
        this.isSign = true;
        this.signResultDialog = true;
        this.getActivityUserInfo();
      }).catch(() => {
        this.isSign = false;
        this.signResultDialog = true;
      })
    },
    dataCountDown(targetTimestamp, type) {
      // 获取当前时间戳
      const currentTimestamp = Date.now();

      // 计算时间差
      let timeRemaining = targetTimestamp - currentTimestamp;

      // 如果时间差小于等于0，表示目标时间已经过去
      if (timeRemaining <= 0) {
        if(type === 1) {
          this.isStepOneHave = false;
          this.isStepOneOver = true;
        } else {
          this.isStepTwoHave = false;
        }
        return;
      }

      // 每隔一秒更新一次时间差
      const intervalId = setInterval(() => {
        // 更新当前时间戳
        const currentTimestamp = Date.now();

        // 重新计算时间差
        timeRemaining = targetTimestamp - currentTimestamp;

        // 如果时间差小于等于0，清除定时器
        if (timeRemaining <= 0) {
          clearInterval(intervalId);
          if(type === 1) {
            this.isStepOneHave = false;
            this.isStepOneOver = true;
          } else {
            this.isStepTwoHave = false;
          }
          return;
        }
        // 格式化时间差并输出
        const formattedTime = this.formatTime(timeRemaining);
        if(type === 1) {
          this.stepOneTime = formattedTime;
        } else {
          this.stepTwoTime = formattedTime;
        }
      }, 1000);
    },
    formatTime(time) {
      // 将时间戳转换为天、小时、分钟和秒
      const days = Math.floor(time / (1000 * 60 * 60 * 24));
      const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((time % (1000 * 60)) / 1000);

      return `${days}天 ${hours}小时 ${minutes}分钟 ${seconds}秒`;
    },
  },
};
</script>

<style lang="less" scoped>
.regressionPC {
  .navBarFixed {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 999;
  }
  .tabbar {
    background-color: #ffffff;
    padding: 10px 19.5%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    
    &-right {
      display: flex;
      align-items: center;
      &-item {
        text-align: center;
        color: #666;
        font-size: 12px;
        cursor: pointer;

        &:first-child {
          margin-right: 2rem;
        }
      }
    }
  }
  .regression_header {
    &-banner {
      width: 100%;
    }

    &-login {
      position: absolute;
      top: 8.2vw;
      right: 19.5%;
      width: 24%;
      height: 22vw;
      background: url('/subject/regression/login-bg.png') no-repeat center;
      background-size: 100% 100%;

      .login-box {
        width: 80%;
        margin: 6vw auto 0;
        input:focus {
          outline: none;
        }
        input {
          width: 100%;
          height: 3.6vw;
          background: #f4f4f4;
          border: 1px solid #f4f4f4;
          border-radius: 10px;
          font-size: 18px;
          text-indent: 15px;
          list-style: none;
          box-sizing: border-box;
          margin-bottom: 20px;
        }

        .codeBox {
          width: 100%;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;

          input {
            width: 100%;
          }

          span {
            width: 120px;
            height: 2.5vw;
            line-height: 2.5vw;
            font-size: 18px;
            border-radius: 6px;
            background: #ffa540;
            text-align: center;
            color: #fff;
            position: absolute;
            top: 0.55vw;
            right: 8px;
            cursor: pointer;
          }
        }

        .loginBtn {
          width: 90%;
          display: block;
          cursor: pointer;
          position: relative;
          margin: auto;
        }
      }
    }

    &-trade {
      position: absolute;
      top: 8.2vw;
      right: 19.5%;
      width: 24%;
      height: 22vw;
      background: url('/subject/regression/logied-bg.png') no-repeat center;
      background-size: 100% 100%;
      text-align: center;
      p {
        margin: 45% 0 6%;
        color: #ba5e1b;
        font-size: 20px;
        font-weight: 600;
        span {
          color: red;
        }
      }
      .tradeBtn {
        width: 76%;
        cursor: pointer;
      }
    }
  }

  .regression_body {
    background: url('/subject/regression/bg.png') no-repeat center;
    background-size: cover;
    padding-top: 60px;
    margin-top: -4px;

    .active-info {
      width: 62%;
      margin: auto;
      background: #fff;
      border-radius: 16px;
      padding: 1.5% 5%;
      margin-bottom: 60px;
      box-sizing: border-box;

      .active-info-time {
        color: red;
      }

      &-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 30px;
        font-weight: 600;
        >span {
          &:first-child {
            color: #ba5e1b;
            font-size: 22px;
          }
          &:last-child {
            display: flex;
            align-items: center;
            color: #666;

            img {
              width: 24px;
              margin-right: 8px;
            }
          }
        }
      }

      &-box {
        text-align: center;
        display: flex;
        justify-content: space-between;
        position: relative;
        &-title {
          margin: 30px 0 30px;
          background: #fffbea;
          color: #953a21;
          border-radius: 80px;
          padding: 9px 10px;
          font-weight: 600;
          white-space: nowrap;
        }
        &-title-deviation {
          position: relative;
          left: -55px;
          width: fit-content;
        }
        >div {
          width: 50%;
        }
        &-left {
          display: flex;
          justify-content: space-between;
          .active-info-box-item {
            position: relative;
            width: 47%;

            img {
              width: 100%;
            }

            .active-status {
              position: absolute;
              bottom: 23%;
              left: 15%;
              right: 15%;
              line-height: 50px;
              font-size: 22px;
              background: #ffc24c;
              color: #fff;
              border-radius: 8px;
            }
            .active-status-filed {
              background: #dddddd;
              color: #666;
            }
          }
        }
        &-right {
          width: 32% !important;
          .active-info-box-item {
            position: relative;
            width: 73%;
            margin: auto;
            img {
              width: 100%;
            }
          }
        }

        .active-target {
          position: absolute;
          bottom: 22.5%;
          left: 8%;
          right: 8%;
          font-size: 20px;
          color: #501700;
          span {
            color: red;
          }
        }

        .right-icon {
          position: absolute;
          top: 50%;
          right: 33%;
          width: 12%;
        }
      }

      &-btn {
        display: flex;
        justify-content: center;
        margin: 36px 0 20px;
        img {
          cursor: pointer;
          width: 29%;
          margin: 0 2%;
        }
      }
    }

    .regression_role {
      width: 55%;
      margin: auto;
      &-bg {
        width: 100%;
        margin-bottom: 20px;
      }
      &-title {
        color: #ae5f40;
        margin: 30px 0 5px;
        font-weight: 700;
        font-size: 18px;
      }
      &-content {
        color: #ae5f40;
        line-height: 28px;
        font-size: 18px;
      }
    }

    .regression_btn {
      display: flex;
      justify-content: center;
      margin: 36px 0 80px;
      img {
        cursor: pointer;
        width: 15%;
        margin: 0 1%;
      }
    }

    .regression_download {
      width: 58%;
      margin: auto;
      text-align: center;
      padding-bottom: 140px;

      &-title {
        color: #a7431c;
        font-size: 48px;
        font-weight: 600;
      }

      &-box {
        background: url('/subject/regression/download-bg.png') no-repeat center;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        padding: 130px 0 60px;
        margin: 60px 0 40px;

        &-code {
          display: flex;
          &:first-child {
            margin-right: 8%;
          }
          &-item {
            margin: 0 26px;
            &-title {
              background: #f4b77b;
              color: #fff;
              border-radius: 6px;
              font-size: 18px;
              line-height: 40px;
              margin: 16px 3px;
            }
            &-titleTwo {
              border: 1px solid #f4b77b;
              color: #f4b77b;
              border-radius: 6px;
              font-size: 18px;
              line-height: 40px;
              margin: 16px 3px;
            }
          }
        }
      }

      &-tips {
        color: #a7431c;
        font-size: 18px;
        line-height: 30px;
        span {
          color: red;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
  }


  .signResultDialog {
    width: 500px;
    height: 356px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    border-radius: 15px;
    z-index: 99;
    text-align: center;
    padding: 20px;

    >div {
      padding-top: 7%;
      p {
        color: #9e1100;
        margin: 15px 0 30px;
        font-size: 24px;
        font-weight: 600;
      }
    }
    
    .hover {
      cursor: pointer;
    }

    .close-btn {
      padding-top: 0;
      text-align: right;
    }
  }

  .dark {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.5;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 95;
  }
}

</style>
